import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown, Send, Globe } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden px-6 py-20" data-id="element-21">
      {/* Atmospheric Background */}
      <div className="absolute inset-0 bg-luxury-gradient z-0 pointer-events-none" data-id="element-22" />

      {/* Content Container */}
      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-23">
        {/* Decorative Top Line */}
        <motion.div initial={{
        opacity: 0,
        scaleX: 0
      }} animate={{
        opacity: 1,
        scaleX: 1
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="w-24 h-[1px] bg-gold-400 mx-auto mb-12" data-id="element-24" />

        {/* Main Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="text-5xl md:text-7xl lg:text-8xl font-bold tracking-tight mb-4 text-gold-100" data-id="element-25">
          <span className="block mb-2 text-4xl md:text-6xl lg:text-7xl" data-id="element-26">
            新加坡顶级伴游服务
          </span>
          <span className="block text-2xl md:text-3xl lg:text-4xl font-normal text-gold-300 mt-4 italic" data-id="element-27">
            Singapore's Premier Companion Service
          </span>
        </motion.h1>

        {/* Tagline */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="text-lg md:text-xl text-gold-600 mt-8 mb-10 tracking-widest uppercase" data-id="element-28">
          十年匠心 · 尊享体验 <span className="mx-2 text-gold-800" data-id="element-29">|</span> A
          Decade of Excellence
        </motion.p>

        {/* Description */}
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.6
      }} className="text-gold-100/80 max-w-2xl mx-auto mb-12 leading-relaxed font-light" data-id="element-30">
          Experience the epitome of sophistication with our curated selection of
          elite companions. Tailored for the discerning gentleman who demands
          nothing but the extraordinary.
        </motion.p>

        {/* CTA Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-31">
          <a href="https://t.me/gl777net" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-gold-400 text-dark-bg px-10 py-5 text-lg font-bold tracking-wide rounded-sm hover:bg-gold-300 transition-all duration-300 shadow-[0_0_20px_rgba(201,169,110,0.3)] hover:shadow-[0_0_30px_rgba(201,169,110,0.5)] transform hover:-translate-y-1" data-id="element-32">
            <Send className="w-5 h-5" data-id="element-33" />
            <span data-id="element-34">Telegram 联系我们</span>
          </a>
          <a href="https://www.geylang777-2.site" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 border border-gold-400/50 text-gold-400 px-10 py-5 text-lg font-bold tracking-wide rounded-sm hover:bg-gold-400 hover:text-dark-bg transition-all duration-300 transform hover:-translate-y-1" data-id="element-35">
            <Globe className="w-5 h-5" data-id="element-36" />
            <span data-id="element-37">访问官网 · Website</span>
          </a>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      delay: 1.5
    }} className="absolute bottom-10 left-1/2 transform -translate-x-1/2 text-gold-600/50" data-id="element-38">
        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-39">
          <ChevronDown className="w-6 h-6" data-id="element-40" />
        </motion.div>
      </motion.div>
    </section>;
}